import { Link } from "react-router-dom";

function CrosswordGeneral() {
    return (
        <section className="content-wrapper">
            <h1>정규 십자말풀이</h1>
            <hr></hr>
            <article>
                <p>
                    <em>정규 십자말풀이</em> 게시판은 십자말풀이이면서 다음 조건들을 따르는 십자말풀이를 모아놓았습니다.
                </p>
                <ul>
                    <li><b>크기.</b> 격자판의 가로 칸과 세로 칸의 길이는 같습니다. 주로 15칸이거나 21칸입니다. </li>
                    <li><b>대칭성.</b> 흰색 칸과 검은색 칸의 위치는 대칭적인 모양을 띕니다. 주로 점대칭이지만 선대칭일 수도 있습니다.</li>
                    <li><b>연결성.</b> 모든 흰색 칸들은 하나로 연결되어 있습니다.</li>
                </ul>
                <div className="milestone-wrapper">
                    <Link to='/crossword/general/list'><span className="milestone">목록으로</span></Link>
                </div>
            </article>
        </section>
    )
}

export default CrosswordGeneral;